import React from "react";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import { REPORT_PRIORITY_POLICIES, REPORT_PRIORITY_POLICY_OPTIONS } from "./systemConfigurationUtils";

const DatastreamPrioritiesConfigPanel = ({ t, reportPriorityPolicy, setReportPriorityPolicy }) => (
  <section className="system-config-panel">
    <div className="system-config-panel-head">
      <div>
        <h3>{t.reportPriorityPolicyTitle || "Datastream report-priority conflicts"}</h3>
        <p>{t.reportPriorityPolicyDescription || "Choose the platform-wide behavior when a user assigns a report priority that is already in use."}</p>
      </div>
      <LowPriorityIcon />
    </div>

    <div className="system-config-options" role="radiogroup" aria-label={t.reportPriorityPolicyTitle || "Report priority conflict policy"}>
      {REPORT_PRIORITY_POLICY_OPTIONS.map((option) => {
        const selected = reportPriorityPolicy === option.value;
        return (
          <button
            type="button"
            key={option.value}
            className={`system-config-option ${selected ? "selected" : ""}`}
            onClick={() => setReportPriorityPolicy(option.value)}
            role="radio"
            aria-checked={selected}
          >
            <span className="system-config-option-icon"><LowPriorityIcon /></span>
            <span>
              <strong>{t.reportPriorityPolicies?.[option.value]?.title || option.title}</strong>
              <small>{t.reportPriorityPolicies?.[option.value]?.description || option.description}</small>
            </span>
            <span className="system-config-radio" />
          </button>
        );
      })}
    </div>

    <div className="system-config-priority-example">
      <strong>{t.reportPriorityExampleTitle || "Example: change priority 1 to priority 4"}</strong>
      <span>
        {reportPriorityPolicy === REPORT_PRIORITY_POLICIES.SHIFT
          ? "The edited datastream becomes 4; the old 4 becomes 5, the old 5 becomes 6, and the cascade stops at the first unused priority."
          : reportPriorityPolicy === REPORT_PRIORITY_POLICIES.SWAP
            ? "The edited datastream becomes 4 and the old priority-4 datastream receives priority 1."
            : "The change is blocked because priority 4 is already assigned."}
      </span>
    </div>
  </section>
);

export default DatastreamPrioritiesConfigPanel;
